import { ProjectMemberJSON } from '@projectMembers/models/projectMember';
import { ProjectMemberRoleType } from '@projectMembers/models/projectRole';
import { ProjectInvitationJSON } from '@projectMembers/models/projectInvitation';

import ReduxTanStackSync from 'src/new_arch/services/ReduxTanStackSync';
import { PROJECT_INVITATIONS_URL, PROJECTS_URL } from '../../../../config/urls';
import Api from '../../../../services/Api';

export default class ProjectMembersSystem {
	private api: Api;
	private sync: ReduxTanStackSync;

	constructor( { api, sync }: { api: Api, sync: ReduxTanStackSync } ) {
		this.api = api;
		this.sync = sync;
	}

	async inviteMembers( {
		projectID, emails, role
	}: { projectID: number, emails: string[], role: ProjectMemberRoleType } ) {
		const inviteURL = `${PROJECTS_URL}/${projectID}/members/invite`;

		const { response } = await (
			this.api.post( inviteURL, { invitees: emails, role } ) as Promise<{ response: ProjectMemberJSON[] }>
		);

		return response;
	}

	async fetchProjectMembers( { projectID }: { projectID: number } ) {
		const membersURL = `${PROJECTS_URL}/${projectID}/members`;

		const { response } = await (
			this.api.get( membersURL ) as Promise<{ response: ProjectMemberJSON[] }>
		);

		this.sync.projectMembers( projectID, response );

		return response;
	}

	async fetchProjectPendingInvites( { projectID }: { projectID: number } ) {
		const invitesURL = `${PROJECTS_URL}/${projectID}/pending_invites`;

		const { response } = await (
			this.api.get( invitesURL ) as Promise<{ response: ProjectInvitationJSON[] }>
		);

		return response;
	}

	async updateProjectMemberRole( {
		projectID, memberID, role
	}: { projectID: number, memberID: number, role: ProjectMemberRoleType } ) {
		const membersURL = `${PROJECTS_URL}/${projectID}/members/${memberID}`;

		const { response } = await (
			this.api.put( membersURL, { role } ) as Promise<{ response: ProjectMemberJSON }>
		);

		this.sync.updateProjectMemberRole( projectID, memberID, role );

		return response;
	}

	async deleteProjectMember( { projectID, memberID }: { projectID: number, memberID: number } ) {
		const membersURL = `${PROJECTS_URL}/${projectID}/members/${memberID}`;

		const { response } = await (
			this.api.delete( membersURL ) as Promise<{ response: ProjectMemberJSON }>
		);

		this.sync.deleteProjectMember( projectID, memberID );

		return response;
	}

	async deleteProjectInvitation( { invitationID }: { invitationID: number } ) {
		const invitesURL = `${PROJECT_INVITATIONS_URL}/${invitationID}`;

		const { response } = await (
			this.api.delete( invitesURL ) as Promise<{ response: ProjectInvitationJSON }>
		);

		return response;
	}
}
